const mutations = {
  'SET_MESSAGES' (state, value) {
    state.messages = value
  },
  'SET_MESSAGE' (state, value) {
    state.message = value
  }
}
export default mutations
